<ng-container *ngIf="message" [ngbTooltip]="tooltipContent" class="tooltip-message">{{message}}</ng-container>
